import React from 'react';
import { NavLink } from 'react-router-dom';
import './LayoutComponents.css';
import timesheetLogo from '../../assets/images/timesheet-logo.png';
import {
  FaHome,
  FaClock,
  FaMoneyBill,
  FaCog,
  FaQuestionCircle,
  FaFileAlt,
  FaClipboardCheck,
} from 'react-icons/fa';
import { useSelector } from 'react-redux';

const Sidebar = ( ) => {
  
  const { user } = useSelector((state) => state.auth);

  // Checks if user has the approval role using data from authSlice.js
  const isApprover = user?.roles?.some(r => r.roleName === "APPROVER");

  const menuItems = [
    { path: '/dashboard', icon: <FaHome />, label: 'Dashboard', approverOnly: false },
    { path: '/timesheets', icon: <FaClock />, label: 'Timesheets', approverOnly: false },
    { path: '/expenses', icon: <FaMoneyBill />, label: 'Expenses', approverOnly: false },
    { path: '/approvals', icon: <FaClipboardCheck />, label: 'Approvals', approverOnly: true},
    { path: '/documents', icon: <FaFileAlt />, label: 'Documents', approverOnly: false },
    { path: '/settings', icon: <FaCog />, label: 'Settings', approverOnly: false },
    { path: '/help', icon: <FaQuestionCircle />, label: 'Help', approverOnly: false },
  ];

  return (
    <aside className="sidebar-container">
      <div className="sidebar-logo">
        <img src={timesheetLogo} alt="EZ Timesheet Logo" className="sidebar-logo-image" />
        <span>EZ Timesheet</span>
      </div>
      <nav className="sidebar-nav-list">
        {menuItems.map((item) => (
          (!item.approverOnly || isApprover ) && (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `sidebar-nav-item ${isActive ? 'active' : ''}`
              }
            >
              {item.icon}
              {item.label}
            </NavLink>
          )
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar; 